import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';

import { MaterialCustomModule } from './material-custom.module';
import { SalesOrderAgInvoicesComponent } from './modules/sales-order/components';
import { SalesOrderApplyPresetComponent } from './modules/sales-order/components/sales-order-apply-preset/sales-order-apply-preset.component';
import { AgGridCustomFilterFormComponent } from './modules/shared/components/ag-grid-custom-filter-form/ag-grid-custom-filter-form.component';
import { AgGridCustomRadioFilterComponent } from './modules/shared/components/ag-grid-custom-radio-filter/ag-grid-custom-radio-filter.component';
import { AgGridDropdownMenuCellRendererComponent } from './modules/shared/components/ag-grid-dropdown-menu-cell-renderer/ag-grid-dropdown-menu-cell-renderer.component';
import { AgGridEditorDateComponent } from './modules/shared/components/ag-grid-editor-date/ag-grid-editor-date.component';
import { AgGridSearchCompanyAutocompleteCellEditorComponent } from './modules/shared/components/ag-grid-search-company-autocomplete-cell-editor/ag-grid-search-company-autocomplete-cell-editor.component';
import { AgGridSidemenuComponent } from './modules/shared/components/ag-grid-sidemenu/ag-grid-sidemenu.component';
import { ChannelControlComponent } from './modules/shared/components/channel-control/channel-control.component';
import { CountryAutocompleteComponent } from './modules/shared/components/country-autocomplete/country-autocomplete.component';
import { ExternalWarehouseControlComponent } from './modules/shared/components/external-warehouse-control/external-warehouse-control.component';
import { PhoneComponent } from './modules/shared/components/phone/phone.component';
import { RfqAutocompleteComponent } from './modules/shared/components/rfq-autocomplete/rfq-autocomplete.component';
import { DirectiveModule } from './modules/shared/directives/directive.module';
import { PipeModule } from './modules/shared/pipes/pipe.module';
import { TagAutocompleteChipComponent } from './modules/tag/components/tag-autocomplete-chip/tag-autocomplete-chip.component';
import { TagsAutocompleteChipDialogComponent } from './modules/tag/components/tags-autocomplete-chip-dialog/tags-autocomplete-chip-dialog.component';
import { UiModule } from './modules/ui/ui.module';
import { FeatureModule } from './shared/feature/feature.module';

const vendorModules = [
  AgGridModule,
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
];
const lumModules = [
  DirectiveModule,
  FeatureModule,
  MaterialCustomModule,
  PipeModule,
  UiModule,
];
const components = [
  AgGridEditorDateComponent,
  AgGridCustomRadioFilterComponent,
  AgGridCustomFilterFormComponent,
  AgGridSidemenuComponent,
  AgGridSearchCompanyAutocompleteCellEditorComponent,
  AgGridDropdownMenuCellRendererComponent,
  ChannelControlComponent,
  CountryAutocompleteComponent,
  RfqAutocompleteComponent,
  PhoneComponent,
  SalesOrderApplyPresetComponent,
  TagAutocompleteChipComponent,
  ExternalWarehouseControlComponent,
  SalesOrderAgInvoicesComponent,
  TagsAutocompleteChipDialogComponent,
];

@NgModule({
  declarations: [...components],
  imports: [...vendorModules, ...lumModules],
  exports: [...components],
})
export class SharedComponentsModule {}
